export class PatientProvisionsNearModel {
    constructor() {
        this.LastProvisionType = 0;
        this.LastProvisionState = 0;
        this.LastProvisionDate="";
        this.NextProvisionType = 0;
        this.NextProvisionDate = "";
    }
}